<template>

  <div>
    <el-row class="table-grid-content">
      <el-col :span="3">
        <el-input v-model="selectorgName" placeholder="请输入机构名称"></el-input>
      </el-col>


      <el-col :span="3" style="margin-left:0.5rem;">
        <el-input v-model="selectorgContact" placeholder="请输入机构联系人"></el-input>
      </el-col>
      <el-col :span="3" style="margin-left:0.5rem;">
        <el-select v-model="selectPurchaseType" placeholder="请选择机构购买类型">
          <el-option key=""
                     label=""
                     value="">全部
          </el-option>
          <el-option
            v-for="item in typeArrs"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>

      </el-col>
      <el-col :span="3" style="margin-left:0.5rem;">
        <el-select v-model="selectEnabled" placeholder="请选择机构状态">
          <el-option key="" label="" value="">全部</el-option>
          <el-option key="1" label="正常" value="1">正常</el-option>
          <el-option key="0" label="删除" value="0">删除</el-option>

        </el-select>
      </el-col>

      <el-col :span="2" class="grid" :offset="1" style="margin-right:0.5rem;">
        <el-button type="success" @click="selectinit" icon="el-icon-search">搜索</el-button>
      </el-col>
      <el-col :span="2" class="grid" :gutter="15" style="margin-right:0.5rem;">
        <el-button type="primary" @click="addParamete()">增加</el-button>
      </el-col>
    </el-row>

    <el-table :data="organzitionData" border style="width: 100%; margin-top: 1rem;">
      <el-table-column prop="id" label="id" v-if="show"></el-table-column>
      <el-table-column prop="orgName" label="机构名称"></el-table-column>
      <el-table-column prop="orgTelphone" label="机构电话"></el-table-column>
      <el-table-column prop="orgModel" label="机构模式"></el-table-column>
      <el-table-column prop="orgContact" label="机构联系人"></el-table-column>
      <el-table-column prop="orgContactTelphone" label="机构联系人电话"></el-table-column>
      <el-table-column prop="orgId" label="机构对应ID"></el-table-column>
      <el-table-column prop="purchaseType" label="购买类型" :formatter="purchaseTypeFormat"></el-table-column>
      <el-table-column prop="purchaseNumber" label="数量"></el-table-column>
      <el-table-column prop="expirationDate" label="机构到期时间">
        <template slot-scope="scope">{{ scope.row.expirationDate| dateFormatYYYYMMDD }}</template>
      </el-table-column>
      <el-table-column prop="jlb" label="俱乐部模式">
        <template slot-scope="scope">
        <el-switch
          v-model="scope.row.jlb"
          active-color="#13ce66"
          inactive-color="#ff4949"
          active-value="1"
          inactive-value="0"
          @change="changeSwitch(scope.row)"
        />
        </template>
      </el-table-column>
      <el-table-column prop="enabled" label="机构状态" :formatter="enabledTypeFormat"></el-table-column>
      <el-table-column label="操作" width=400px>
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="organzitionEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button type="danger" size="small" @click="organzitionDelete(scope.row)">删除</el-button>
          <el-button type="bindingWeChat" size="small" @click="bindingPayInfo(scope.$index, scope.row,2)">绑定支付宝
          </el-button>
          <el-button type="bindingAlipay" size="small" @click="bindingPayInfo(scope.$index, scope.row,1)">绑定微信
          </el-button>

        </template>
      </el-table-column>
    </el-table>


    <el-pagination
      @size-change="sizeChange"
      @current-change="currentChange"
      :page-sizes="[10]"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next"
      :total="page.totalRecords">
    </el-pagination>


    <!--新增-->
    <el-dialog title="新增机构" :visible="addorganzitionForm" size="tiny" :modal-append-to-body='false'
               @close='closeDialog'>
      <el-form id="#addsForm" ref="addsForm" :model="addsForm" label-width="200px">
        <el-input v-model="addsForm.logoUrl" v-if="value"></el-input>
        <el-form-item label="机构名称" prop="orgName" :rules="[{required: true,message: '请输入正确值', trigger: 'blur' }]">
          <el-input v-model="addsForm.orgName" max-length="10"></el-input>
        </el-form-item>
        <el-form-item label="机构电话" prop="orgTelphone" :rules="[{required: true,message: '请输入正确值', trigger: 'blur' }]">
          <el-input type="number" min=0 v-model="addsForm.orgTelphone" max-length="10"></el-input>
        </el-form-item>
        <el-form-item label="机构logo" prop="logoUrl">
          <el-upload
            class="upload-demo"
            ref="upload"
            :on-success="handleSuccess"
            :action="apiUrl+'/manageOrganizations/upload'"
            :file-list="fileList"
            :auto-upload="false">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="机构面积" prop="orgSize">
          <el-input type="number" min=0 v-model="addsForm.orgSize" max-length="10"></el-input>
        </el-form-item>
        <el-form-item label="购买模式" prop="orgModel">
          <el-select v-model="addsForm.orgModel" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="机构代码" prop="orgCode" :rules="[{required: true,message: '请输入正确值', trigger: 'blur' }]">
          <el-input v-model="addsForm.orgCode" ref="orgCode"></el-input>
        </el-form-item>
        <el-form-item label="机构联系人" prop="orgContact" :rules="[{required: true,message: '请输入正确值', trigger: 'blur' }]">
          <el-input v-model="addsForm.orgContact"></el-input>
        </el-form-item>
        <el-form-item label="机构联系人电话" prop="orgContactTelphone"
                      :rules="[{required: true,message: '请输入正确值', trigger: 'blur' }]">
          <el-input type="number" min=0 v-model="addsForm.orgContactTelphone"></el-input>
        </el-form-item>
        <el-form-item label="机构联系人微信号" prop="orgContactWxid"
                      :rules="[{required: true,message: '请输入正确值', trigger: 'blur' }]">
          <el-input v-model="addsForm.orgContactWxid"></el-input>
        </el-form-item>
        <el-form-item label="机构联系人邮箱" prop="orgContactMail"
                      :rules="[{required: true,message: '请输入正确值', trigger: 'blur' }]">
          <el-input v-model="addsForm.orgContactMail"></el-input>
        </el-form-item>
        <el-form-item label="购买类型" prop="purchaseType">
          <el-select v-model="addsForm.purchaseType" placeholder="请选择">
            <el-option
              v-for="item in typeArrs"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学区或学员数量" prop="purchaseNumber">
          <el-input type="number" min=0 v-model="addsForm.purchaseNumber"></el-input>
        </el-form-item>
        <el-form-item label="开通时间" prop="openingDateString">
          <el-date-picker
            v-model="addsForm.openingDate"
            type="date"
            placeholder="选择日期">
          </el-date-picker>

        </el-form-item>
        <el-form-item label="到期时间" prop="expirationDateString">
          <el-date-picker
            v-model="addsForm.expirationDate"
            type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="选择版本" prop="purchaseType">
          <el-select v-model="addsForm.editionId" placeholder="请选择">
            <el-option
              v-for="item in typeArrs2"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="studentAdd()">确定</el-button>
          <el-button @click="addorganzitionForm = false;">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!--修改-->
    <el-dialog title="修改机构信息" :visible="editorganzitionForm" size="tiny" :modal-append-to-body='false'
               @close='closeDialog'>
      <el-form id="#editsForm" ref="editsForm" :model="editsForm" label-width="200px">

        <el-input v-model="editsForm.id" v-if="value"></el-input>
        <el-input v-model="editsForm.logoUrl" v-if="value"></el-input>

        <el-form-item label="机构名称" prop="orgName">
          <el-input v-model="editsForm.orgName" max-length="10" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="机构电话" prop="orgTelphone">
          <el-input v-model="editsForm.orgTelphone" max-length="10" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="机构logo" prop="logoUrl">

          <el-upload
            class="upload-demo"
            ref="upload"
            :on-success="handleSuccess"
            :action="apiUrl+'/manageOrganizations/upload'"
            :file-list="fileList"
            :auto-upload="false">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="机构面积" prop="orgSize">
          <el-input v-model="editsForm.orgSize" max-length="10" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="购买模式" prop="orgModel">
          <el-input v-model="editsForm.orgModel" max-length="10" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="机构代码" prop="orgCode">
          <el-input v-model="editsForm.orgCode" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="机构联系人" prop="orgContact">
          <el-input v-model="editsForm.orgContact"></el-input>
        </el-form-item>
        <el-form-item label="机构联系人电话" prop="orgContactTelphone">
          <el-input type="number" min=0 v-model="editsForm.orgContactTelphone"></el-input>
        </el-form-item>
        <el-form-item label="机构联系人微信号" prop="orgContactWxid">
          <el-input v-model="editsForm.orgContactWxid"></el-input>
        </el-form-item>
        <el-form-item label="机构联系人邮箱" prop="orgContactMail">
          <el-input v-model="editsForm.orgContactMail"></el-input>
        </el-form-item>
        <el-form-item label="购买类型" prop="purchaseType">
          <el-select v-model="editsForm.purchaseType" placeholder="请选择" :disabled="true">
            <el-option
              v-for="item in typeArrs"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学区或学员数量" prop="purchaseNumber">
          <el-input type="number" min=0 v-model="editsForm.purchaseNumber"></el-input>
        </el-form-item>
        <el-form-item label="到期时间" prop="expirationDate">
          <el-date-picker
            v-model="editsForm.expirationDate"
            type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="选择版本" prop="purchaseType">
          <el-select v-model="editsForm.editionId" placeholder="请选择">
            <el-option
              v-for="item in typeArrs2"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="studentEdit()">确定</el-button>
          <el-button @click="editorganzitionForm = false;">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>


    <!--绑定支付信息-->
    <el-dialog :title="titleData" :visible="bindingPayInfoForm" size="tiny" :modal-append-to-body='false'
               @close='closeDialog'>
      <el-form id="#bindingForm" ref="bindingForm" :model="bindingForm" label-width="200px">
        <el-input v-model="bindingForm.orgId" v-if="value"></el-input>
        <el-input v-model="bindingForm.payType" v-if="value"></el-input>
        <el-form-item label="appkey" prop="appkey">
          <el-input v-model="bindingForm.appkey" max-length="10"></el-input>
        </el-form-item>
        <el-form-item label="appsecret" prop="appsecret">
          <el-input v-model="bindingForm.appsecret" max-length="10"></el-input>
        </el-form-item>
        <el-form-item label="appublicKey" prop="appublicKey">
          <el-input v-model="bindingForm.appublicKey" max-length="10"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="paymentAdd()">确定</el-button>
          <el-button @click="bindingPayInfoForm = false;">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
import {formatTimeToStr} from './js/date.js';
<script>
export default {
  data() {
    return {
      timer:null,
      value: false,
      show: false,
      titleData: "fhifu",
      addorganzitionForm: false,
      editorganzitionForm: false,
      bindingPayInfoForm: false,
      organzitionData: [],
      selectorgName: "",
      selectorgContact: "",
      selectPurchaseType: "",
      selectEnabled: "",
      page: {
        pageSize: 10, //每页条数,  默认10条
        totalRecords: 0, //总条数
        totalPages: 0, //总页数
        pageNum: 0
      },
      options: [{
        value: '直营',
        label: '直营'
      }, {
        value: '加盟',
        label: '加盟'
      }, {
        value: '代理',
        label: '代理'
      }, {
        value: '合作',
        label: '合作'
      }],
      typeArrs: [{
        value: 1,
        label: '按校区数购买'
      }, {
        value: 2,
        label: '按学员数购买'
      }],
      typeArrs2: [],
      typeArr3: [{
        value: 3,
        label: '实打实大苏打实打实大苏打撒旦'
      }, {
        value: 2,
        label: '按学员数购买'
      }],
      addsForm: {
        orgName: '',
        orgTelphone: '',
        orgSize: 0,
        orgModel: '',
        orgCode: '',
        orgContact: '',
        orgContactTelphone: '',
        purchaseNumber: 0,
        openingDate: '',
        expirationDate: '',
        orgContactMail: '',
        orgContactWxid: '',
        logoUrl: '',
        editionId: '',
        purchaseType: ''
      } ,
      editsForm: {
        id: '',
        orgName: '',
        orgTelphone: '',
        orgSize: 0,
        orgModel: '',
        orgCode: '',
        orgContact: '',
        orgContactTelphone: '',
        purchaseNumber: 0,
        expirationDate: '',
        orgContactMail: '',
        orgContactWxid: '',
        logoUrl: '',
        editionId: '',
        editionName: ''
      },
      bindingForm: {
        orgId: '',
        payType: '',
        appkey: '',
        appsecret: '',
        appublicKey: ''
      },
      apiUrl: '',
      fileList: []


    }
  },
  created() {
    this.apiUrl = localStorage.aipUrl
  },
  mounted() {
    this.getManageEditionSelect()
    this.init();

  },
  methods: {
    submitUpload() {
      this.$refs.upload.submit();

    },

    // 文件上传成功时的钩子
    handleSuccess(res, file, fileList) {

      this.addsForm.logoUrl = res.data.url;
      this.editsForm.logoUrl = res.data.url;
      this.fileList = [];

    },
    enabledTypeFormat(row, column) {
      if (row.enabled === 1) {
        return '正常'
      } else {
        return '已删除或禁用'
      }
    },

    purchaseTypeFormat(row, column) {
      if (row.purchaseType === 1) {
        return '按校区购买'
      } else {
        return '按学员数购买'
      }
    },
    selectinit() {
      this.page.pageNum = 0;
      this.init();
    },
    init() {
      this.organzitionData = [];
      let {pageNum, pageSize} = this.page;
      this.axios({
        method: 'post',
        url: this.apiUrl + "/manageOrganizations/manageOrganizationsFind?" + (new Date()).valueOf(),
        data: {
          pageNum: this.page.pageNum,
          orgName: this.selectorgName,
          orgContact: this.selectorgContact,
          purchaseType: this.selectPurchaseType,
          enabled: this.selectEnabled
        },

        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': sessionStorage.getItem("token")
        }
      }).then(res => {
        if (res.data.stateCode == 200) {
          this.page.totalRecords = res.data.data.totalRecords; //总条数
          const studentArray = res.data.data.list;
          this.organzitionData = studentArray;
        } else if (res.data.stateCode == 403) {
          this.$message.error("您没有相应操作权限，请联系系统管理员！");
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(error => {

      })


    },

    getManageEditionSelect() {
      this.axios({
        method: 'post',
        url: this.apiUrl + "/manageEdition/getManageEditionSelect?" + (new Date()).valueOf(),
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': sessionStorage.getItem("token")
        }
      }).then(res => {
        this.typeArrs2 = res.data

      }).catch(error => {

      })
    },
    // 每页显示多少条数据
    sizeChange(val) {
      this.page.pageSize = val;
      this.init();
    },
//翻页
    currentChange(val) {
      this.page.pageNum = val - 1;
      console.log(this.page.pageNum);

      this.init();
    },
// 点击模态框关闭按钮关闭模态框
    closeDialog() {
      this.addorganzitionForm = false;
      this.editorganzitionForm = false;
    },
// 点击新增按钮
    addParamete() {
      this.addsForm = {
        orgTelphone: '',
        orgSize: 0,
        orgModel: '',
        orgCode: '',
        orgContact: '',
        orgContactTelphone: '',
        purchaseNumber: 0,
        openingDate: '',
        expirationDate: '',
        orgContactMail: '',
        orgContactWxid: '',
        logoUrl: '',
        editionId: '',
        purchaseType: ''
      }
      if (this.$refs.addsForm !== undefined) {
        this.$refs.addsForm.resetFields();
      }
      this.addorganzitionForm = true;   //原来隐藏的新增信息模态框显示
    },
//确定
    studentAdd() {
      let parameteList = this.addsForm;
      let {
        orgName,
        orgTelphone,
        orgSize,
        orgModel,
        presentPrice,
        orgCode,
        orgContact,
        orgContactTelphone,
        openingDateString
      } = parameteList;
//判断数据是否为空
      if (orgName == '' || orgTelphone == '' || orgSize == '' || orgModel == '' || orgCode == '' || orgContact == '' || orgContactTelphone == '') {
        this.$message.error('新增内容每一项都不准为空')
      } else {
        if(this.timer !== null){
            clearTimeout(this.timer)
          }
        this.timer = setTimeout(()=>{
          //每一条都不为空时才向后台发送http请求
        this.axios({
          method: 'post',
          url: `${this.apiUrl}/manageOrganizations/manageOrganizationsAdd?` + (new Date()).valueOf(),
          data: {
            orgName: this.addsForm.orgName,
            orgTelphone: this.addsForm.orgTelphone,
            orgSize: this.addsForm.orgSize,
            orgModel: this.addsForm.orgModel,
            orgCode: this.addsForm.orgCode,
            orgContact: this.addsForm.orgContact,
            orgContactTelphone: this.addsForm.orgContactTelphone,
            purchaseType: this.addsForm.purchaseType,
            purchaseNumber: this.addsForm.purchaseNumber,
            openingDate: this.addsForm.openingDate,
            expirationDate: this.addsForm.expirationDate,
            orgContactMail: this.addsForm.orgContactMail,
            orgContactWxid: this.addsForm.orgContactWxid,
            logoUrl: this.addsForm.logoUrl,
            editionId: this.addsForm.editionId

          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': sessionStorage.getItem("token")
          }
        }).then(res => {
          if (res.data.stateCode == 200) {
            this.$set(this.addsForm, {});
            this.init();   //重新渲染数据列表
            this.addorganzitionForm = false;
            this.$message({
              message: res.data.msg,
              type: 'success'
            });
          } else if (res.data.stateCode == 501) {
            alert(res.data.msg);
            this.$refs['orgCode'].focus()
          } else if (res.data.stateCode == 403) {
            this.$message.error("您没有相应操作权限，请联系系统管理员！");
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch(error => {

        })
        },500)



      }
    },
// 点击修改修改按钮
    organzitionEdit(index, row) {
      this.editorganzitionForm = true; //编辑信息模态框显示

      this.editsForm = Object.assign({}, row);
      //获得所有数据显示在编辑信息模态框里面
      console.log(this.editsForm)
      console.log(this.typeArrs2)
      console.log(this.typeArrs)
    },
//绑定支付信息
    bindingPayInfo(index, row, paytype) {
      if (paytype == 1) {
        this.titleData = '微信'
      } else {
        this.titleData = "支付宝"
      }

      this.bindingForm.orgId = row.orgId;
      this.bindingForm.payType = paytype;
      this.axios({
        method: 'post',
        url: `${this.apiUrl}/PaymentInfo/findPayment?` + (new Date()).valueOf(),
        data: {
          orgId: row.orgId,
          payType: paytype
        },
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': sessionStorage.getItem("token")
        }
      }).then(res => {
        if (res.data.stateCode == 200) {
          this.bindingForm.appkey = res.data.data.appkey;
          this.bindingForm.appsecret = res.data.data.appsecret;
          this.bindingForm.appublicKey = res.data.data.apppublickey;
          this.bindingPayInfoForm = true;
        } else if (res.data.stateCode == 403) {
          this.$message.error("您没有相应操作权限，请联系系统管理员！");
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(error => {

      })

    },
//支付信息添加
    paymentAdd() {
      let parameteList = this.bindingForm;
      let {appkey, appsecret, appublicKey} = parameteList;
      if (appkey == '' || appsecret == '' || appublicKey == '') {
        this.$message.error('新增内容每一项都不准为空')
      } else {
        this.axios({
          method: 'post',
          url: `${this.apiUrl}/PaymentInfo/paymentAdd?` + (new Date()).valueOf(),
          data: {
            orgId: this.bindingForm.orgId,

            payType: this.bindingForm.payType,
            appkey: this.bindingForm.appkey,

            appsecret: this.bindingForm.appsecret,

            appublicKey: this.bindingForm.appublicKey

          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': sessionStorage.getItem("token")
          }
        }).then(res => {
          if (res.data.stateCode == 200) {
            this.bindingPayInfoForm = false;
            this.$message({
              message: res.data.msg,
              type: 'success'
            });
          } else if (res.data.stateCode == 403) {
            this.$message.error("您没有相应操作权限，请联系系统管理员！");
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch(error => {

        })
      }


    },
    organzitionDelete(row) {
      this.$confirm('此操作将删除机构 ' + row.orgName + ', 是否继续?', '提示', {type: 'warning'})
        .then(() => { // 向服务端请求删除
          this.axios({
            method: 'post',
            url: `${this.apiUrl}/manageOrganizations/manageOrganizationsDel?` + (new Date()).valueOf(),
            data: {
              id: row.id,
              orgId: row.orgId

            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8',
              'Authorization': sessionStorage.getItem("token")
            }
          }).then(res => {
            if (res.data.stateCode == 200) {
              this.init();   //重新渲染数据列表
              this.$message({
                message: res.data.msg,
                type: 'success'
              });
            } else if (res.data.stateCode == 403) {
              this.$message.error("您没有相应操作权限，请联系系统管理员！");
            } else {
              this.$message.error(res.data.msg);
            }
          }).catch(error => {

          })
        }).catch(() => {
        this.$message.info('已取消操作!');
      });
    },

//修改确定
    studentEdit() {
      let parameteList = this.editsForm;
      let {orgContact, orgContactTelphone, expirationDateString, purchaseNumber} = parameteList;
//判断数据是否为空
      if (orgContact == '' || orgContactTelphone == '' || expirationDateString == '' || purchaseNumber == '') {
        this.$message.error('新增内容每一项都不准为空')
      } else {
//每一条都不为空时才向后台发送http请求
        this.axios({
          method: 'post',
          url: `${this.apiUrl}/manageOrganizations/manageOrganizationsUpdate?` + (new Date()).valueOf(),
          data: {
            id: this.editsForm.id,

            orgContact: this.editsForm.orgContact,
            orgContactTelphone: this.editsForm.orgContactTelphone,
            purchaseNumber: this.editsForm.purchaseNumber,
            expirationDate: this.editsForm.expirationDate,
            orgContactMail: this.editsForm.orgContactMail,
            orgContactWxid: this.editsForm.orgContactWxid,
            logoUrl: this.editsForm.logoUrl,
            editionId: this.editsForm.editionId,
            editionName: this.editsForm.editionName,
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': sessionStorage.getItem("token")
          }
        }).then(res => {
          if (res.data.stateCode == 200) {
            this.init();   //重新渲染数据列表
            this.editorganzitionForm = false;
            this.$message({
              message: res.data.msg,
              type: 'success'
            });
          } else if (res.data.stateCode == 403) {
            this.$message.error("您没有相应操作权限，请联系系统管理员！");
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch(error => {

        })


      }
    }
  }
}
</script>


<style scoped>

.el-table /deep/ th {
  background-color: #EEEFF1;
}

</style>



// WEBPACK FOOTER //
// src/views/organzitionList.vue